import { CaseUtil } from '@vectord/utils';

export enum ComparatorUnits {
  Is = 'is',
  IsNot = 'is_not',
  LessThanOrEqualTo = 'less_than_or_equal_to',
  GreaterThanOrEqualTo = 'greater_than_or_equal_to',
  IsNotDefined = 'is_not_defined',
  IsDefined = 'is_defined',
  Contain = 'contain',
  DoesNotContainData = 'does_not_contain_data',
  ContainsData = 'contains_data',
  Before = 'before',
  After = 'after',
}

export enum CompareAsUnits {
  Text = 'text',
  Time = 'time',
  Number = 'number',
  Date = 'date',
}

export const UNIT_CONFIG = {
  [CompareAsUnits.Text]: {
    validOptions: [
      ComparatorUnits.Is,
      ComparatorUnits.IsNot,
      ComparatorUnits.Contain,
      ComparatorUnits.ContainsData,
      ComparatorUnits.DoesNotContainData,
    ],
  },
  [CompareAsUnits.Time]: {
    validOptions: [
      ComparatorUnits.Is,
      ComparatorUnits.IsNot,
      ComparatorUnits.Before,
      ComparatorUnits.After,
      ComparatorUnits.IsDefined,
      ComparatorUnits.IsNotDefined,
    ],
  },
  [CompareAsUnits.Date]: {
    validOptions: [
      ComparatorUnits.Is,
      ComparatorUnits.IsNot,
      ComparatorUnits.Before,
      ComparatorUnits.After,
      ComparatorUnits.IsDefined,
      ComparatorUnits.IsNotDefined,
    ],
  },
  [CompareAsUnits.Number]: {
    validOptions: [
      ComparatorUnits.Is,
      ComparatorUnits.IsNot,
      ComparatorUnits.LessThanOrEqualTo,
      ComparatorUnits.GreaterThanOrEqualTo,
    ],
  },
};

export const KEYS_WITHOUT_RHS = [
  ComparatorUnits.ContainsData,
  ComparatorUnits.DoesNotContainData,
  ComparatorUnits.IsDefined,
  ComparatorUnits.IsNotDefined,
];

export const getCompareAsOptions = Object.values(CompareAsUnits).map(
  (unit) => ({
    label: CaseUtil.toCase('titleCase', unit) as string,
    value: unit,
  }),
);

export const getComparatorOptionsForUnit = (unit: CompareAsUnits) => UNIT_CONFIG[unit].validOptions.map((option) => ({
  label: CaseUtil.toCase('titleCase', option) as string,
  value: option,
}));
